import '../styles/main.css';
import { initNeuralCanvas } from './canvas.js';
import { initNavigation } from './navigation.js';
import { initMetrics } from './metrics.js';
import { initTabs } from './tabs.js';
import { initForm } from './form.js';
import { initObserver } from './observer.js';

document.addEventListener('DOMContentLoaded', () => {
  const canvasControls = initNeuralCanvas();
  initNavigation();
  initMetrics();
  initTabs();
  initForm();
  initObserver(canvasControls);

  // Set dynamic year in footer
  const yearElem = document.getElementById('current-year');
  if (yearElem) {
    yearElem.textContent = new Date().getFullYear();
  }
});
